import React, {Fragment} from 'react'
import ReactDOM from 'react-dom'
import {NoticeBar} from 'common/styleguide/NoticeBar'
import {urls} from 'lib/urls'
import _ from 'lodash'

export class LiveLogStatusBar extends React.PureComponent {
  constructor (props) {
    super(props)
    this._throttledResize = _.throttle(this.onResize, 300, {trailing: true})
  }

  componentDidMount () {
    const {liveLog, monitorResize} = this.props
    if (liveLog.finalized && monitorResize) {
      this.onResize()
      window.addEventListener('resize', this._throttledResize)
    }
  }

  componentWillUnmount () {
    if (this.props.monitorResize) {
      window.removeEventListener('resize', this._throttledResize)
    }
  }

  // because the ll status bar can wrap -> has indeterminite height before render,
  // we need the ability to measure the clientHeight of this component and update
  // LiveLogPage with our height so we can know how much `top` to add to
  // FullscreenButton (which is positioned absolutely)
  // i consider this whole mess a big dumb HACK
  onResize = () => {
    const {liveLog, monitorResize, updateSBHeight} = this.props

    if (liveLog.finalized && monitorResize && updateSBHeight) {
      updateSBHeight(ReactDOM.findDOMNode(this._ref).clientHeight)
    }
  }

  render () {
    const {user, liveLog, completed, unstarted, onRequestClose} = this.props

    if (!liveLog.finalized) {
      return null
    }

    return (
      <NoticeBar ref={r => { this._ref = r }} onRequestClose={onRequestClose}>
        {completed && <Fragment>
          {user.name} has completed this ride.  <a href={urls.trips.show(liveLog.tripId)}>View the complete ride here.</a>
        </Fragment>}
        {unstarted && <Fragment>
          {user.name} is not currently Live Logging. This page will begin updating as soon as a ride starts.
        </Fragment>}
      </NoticeBar>
    )
  }
}
